import { render, staticRenderFns } from "./showPologicalDetail.vue?vue&type=template&id=24f72446&scoped=true&"
import script from "./showPologicalDetail.vue?vue&type=script&lang=js&"
export * from "./showPologicalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f72446",
  null
  
)

export default component.exports